"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardActionArea = void 0;
var CardActionArea_1 = __importDefault(require("@mui/material/CardActionArea"));
var patch_base_button_components_1 = __importDefault(require("./patch-base-button-components"));
exports.CardActionArea = (0, patch_base_button_components_1.default)(CardActionArea_1.default);
//# sourceMappingURL=card-action-area.js.map